import React from 'react'

import LogoGold from 'icons/logo-gold.svg'
import {
  Mono,
  ChromeWrap,
  ChromeMono,
  ChromeRich,
  LOGO_UMBER_SRC,
  GoldWrap,
  Gold,
  Sheen,
  SheenBand
} from './index.styled'

export const LOGO_TITLE = 'AERA Nomad'

/**
 * The AERA Nomad lockup.
 *
 * @param variant      'mono' (default) paints with `currentColor` so it inherits
 *                     whatever colour its parent sets; 'chrome' is the header
 *                     pair — the flat pale cut over imagery, the metallic one on
 *                     cream, cross-faded off `--chrome-dark`; 'gold' renders the
 *                     Champagne Gold lockup the splash uses.
 * @param shimmer      Gold only: runs the champagne sheen across the letterforms
 *                     once, on the splash's cadence. See the note in
 *                     index.styled.js for where its geometry comes from.
 * @param width        Design-px width of the lockup. Height follows the 112:50
 *                     aspect ratio.
 * @param mobileWidth  Optional width in *mobile* design px, for the places the
 *                     mobile comps resize the lockup (footer 94, splash 270).
 */
const Logo = ({
  variant = 'mono',
  shimmer = false,
  width = 112,
  mobileWidth,
  className,
  ...props
}) => {
  if (variant === 'chrome') {
    return (
      <ChromeWrap
        className={className}
        $width={width}
        $mobileWidth={mobileWidth}
        role='img'
        aria-label={LOGO_TITLE}
        {...props}
      >
        <ChromeRich src={LOGO_UMBER_SRC} alt='' />
        <ChromeMono aria-hidden />
      </ChromeWrap>
    )
  }

  if (variant === 'gold') {
    return (
      <GoldWrap
        className={className}
        $width={width}
        $mobileWidth={mobileWidth}
        role='img'
        aria-label={LOGO_TITLE}
        {...props}
      >
        <Gold src={LogoGold} alt='' />
        {shimmer && <Sheen aria-hidden><SheenBand /></Sheen>}
      </GoldWrap>
    )
  }

  return (
    <Mono
      className={className}
      $width={width}
      $mobileWidth={mobileWidth}
      role='img'
      aria-label={LOGO_TITLE}
      {...props}
    />
  )
}

export default Logo
